import OpenQuery from 'pages/home/ribbon/components/controls/query/OpenQuery';

const OpenSection = () => {
  return <OpenQuery />;
};

export default OpenSection;
